import Cookies from 'js-cookie';

export const setAuthToken = (tokenString) => {
    const parts = tokenString.split('; ');
    const tokenPart = parts.find(part => part.startsWith('authorization='));
    const expiresPart = parts.find(part => part.startsWith('Expires='));

    if (tokenPart && expiresPart) {
        const token = tokenPart.split('=')[1];
        const expires = new Date(expiresPart.split('=')[1]);
        Cookies.set('authToken', token, {
            expires: expires, // 15 minutes expiration
            secure: true,
            sameSite: 'Strict',
        });
        Cookies.set('authTokenExpires', expires.toISOString(), {
            expires: expires, // 15 minutes expiration
            secure: true,
            sameSite: 'Strict',
        });

    } else {
        console.error('Invalid token string');
    }
};

export const isTokenExpired = () => {
    const token = Cookies.get('authToken');
    const expires = Cookies.get('authTokenExpires');

    if (!token || !expires) {
        console.log('No token or expiration date found');
        return true;
    }

    const expirationDate = new Date(expires);
    const now = new Date();

    return now > expirationDate;
};

export const removeAuthCookies = () => {
    Cookies.remove('authToken');
    Cookies.remove('authTokenExpires');
}